// Import dom-to-image-more
import domtoimage from 'dom-to-image-more';
//let domtoimage;

$(document).on("taydu2_cuuthienhuyennu_popup rendered", {}, function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
    $(".close").each(function () {
        $(this).on("click", function () {
            $(this).closest(".popup").removeClass("active");
        })
    })
    // Function to get the scrollTop of the top-level parent window
    var idPopup = "";
    var linkRule = "";
    $(".btn-openpopup").each(function () {
        $(this).on("click", function () {
            idPopup = $(this).data("target")
            
                linkRule = $(this).data("link")
                setTimeout(function () {
                    $("#popup_thele iframe").attr("src", linkRule)
                }, 100)
            
            $(`#${idPopup}`).addClass("active")
            return false
        })
    })
    
    // Xử lý click cho .btn_chuc
    // $(".btn_chuc").each(function () {
    //     $(this).on("click", function (e) {
    //         e.preventDefault();
    //         var targetId = $(this).data("target");
    //         if (targetId) {
    //             $(`#${targetId}`).addClass("active");
    //         }
    //         return false;
    //     })
    // })
    const turnElementP = document.querySelector(".gr_thiep .gr_luot .turn");
    const thanhTienDoP = document.querySelector(".gr_thiep .thanh-white");

    if (turnElementP && thanhTienDoP) {
        const turn = parseInt(turnElementP.textContent, 10);
        
        if (!isNaN(turn)) {
        if (turn <= 1000 && turn > 0) {
            thanhTienDoP.classList.add("moc-1");
        } else if (turn <= 5000 && turn > 1000) {
            thanhTienDoP.classList.add("moc-2");
            $(".gr_thiep .moc-1").find("img.normal").hide();
            $(".gr_thiep .moc-1").find("img.active").show();
        } else if (turn <= 10000 && turn > 5000) {
            thanhTienDoP.classList.add("moc-3");
            $(".gr_thiep .moc-1,.gr_thiep .moc-2").find("img.normal").hide();
            $(".gr_thiep .moc-1,.gr_thiep .moc-2").find("img.active").show();
        } else if (turn <= 20000 && turn > 10000) {
            thanhTienDoP.classList.add("moc-4");
            $(".gr_thiep .moc-1,.gr_thiep .moc-2,.gr_thiep .moc-3").find("img.normal").hide();
            $(".gr_thiep .moc-1,.gr_thiep .moc-2,.gr_thiep .moc-3").find("img.active").show();
        } else if (turn <= 50000 && turn > 20000) {
            thanhTienDoP.classList.add("moc-5");
            $(".gr_thiep .moc-1,.gr_thiep .moc-2,.gr_thiep .moc-3,.gr_thiep .moc-4").find("img.normal").hide();
            $(".gr_thiep .moc-1,.gr_thiep .moc-2,.gr_thiep .moc-3,.gr_thiep .moc-4").find("img.active").show();
        } else if (turn >= 50000) {
            thanhTienDoP.classList.add("moc-6");
            $(".gr_thiep .moc-1,.gr_thiep .moc-2,.gr_thiep .moc-3,.gr_thiep .moc-4,.gr_thiep .moc-5").find("img.normal").hide();
            $(".gr_thiep .moc-1,.gr_thiep .moc-2,.gr_thiep .moc-3,.gr_thiep .moc-4,.gr_thiep .moc-5").find("img.active").show();
        }
        } 
        // else {
        //   console.warn("Turn value is not a valid number:", turnElement.textContent);
        // }
    } 
    if ($('.btn_luu').length > 0) {
        document.querySelector('.btn_luu').addEventListener('click', function (e) {
            e.preventDefault();
        
            const textarea = document.querySelector('.gr_thiep textarea');
            const preview = document.querySelector('.gr_thiep .preview-text');
            const card = document.getElementById('card');
        
            if (!textarea || !preview || !card) {
                console.error('Không tìm thấy các element cần thiết');
                return;
            }
        
            // Gán nội dung textarea vào preview
            const text = textarea.value;
            preview.textContent = text;
        
            // Đảm bảo ẩn textarea hoàn toàn và chỉ hiển thị preview
            textarea.style.display = 'none';
            textarea.style.visibility = 'hidden';
            textarea.style.opacity = '0';
            
            preview.style.display = 'block';
            preview.style.visibility = 'visible';
            preview.style.opacity = '1';
        
            // Đợi một chút để DOM cập nhật
            setTimeout(function() {
                // Chụp ảnh với bộ lọc bỏ các phần tử có class không liên quan
                domtoimage.toPng(card, {
                    filter: (node) => {
                        if (node.tagName === 'LINK') return false;
                        if (node.className && typeof node.className === 'string') {
                            return !node.className.includes('fancybox');
                        }
                        return true;
                    },
                    quality: 1.0
                }).then(function (dataUrl) {
                    // Tạo và tải ảnh
                    const link = document.createElement('a');
                    link.download = 'thiep-chuc-mung.png';
                    link.href = dataUrl;
                    link.click();
                
                    // Khôi phục lại textarea
                    preview.style.display = 'none';
                    preview.style.visibility = 'hidden';
                    preview.style.opacity = '0';
                    
                    textarea.style.display = 'block';
                    textarea.style.visibility = 'visible';
                    textarea.style.opacity = '1';
                }).catch(function (error) {
                    console.error('Lỗi khi tạo ảnh:', error);
                    // Trong mọi trường hợp lỗi, vẫn khôi phục textarea
                    preview.style.display = 'none';
                    preview.style.visibility = 'hidden';
                    preview.style.opacity = '0';
                    
                    textarea.style.display = 'block';
                    textarea.style.visibility = 'visible';
                    textarea.style.opacity = '1';
                });
            }, 50);
        });
    }
});